import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { SelectBandList } from "./SelectBandList";
import { useSelectBandReport } from "./useSelectBandReport";

interface SelectBandCardProps {
  startDate?: string;
  endDate?: string;
}

export const SelectBandCard = ({ startDate, endDate }: SelectBandCardProps = {}) => {
  const { items, labelHeader, loading, error } = useSelectBandReport({ startDate, endDate });

  if (loading) {
    return (
      <Box sx={{ height: 180, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography variant="body2" color="error">
        Failed to load chart.
      </Typography>
    );
  }

  return (
    <SelectBandList
      items={items}
      limit={5}
      showSecondary={false}
      labelHeader={labelHeader}
    />
  );
};
